// Shared secret-masking helpers for display. Pure + client-safe.

/** first4 + stars + last4 (e.g. `aef1****2dff`); ≤8 chars returned as-is. */
export function maskSecret(value: string): string {
  if (!value || value.length <= 8) return value
  return value.substring(0, 4) + "*".repeat(value.length - 8) + value.substring(value.length - 4)
}

/** first3 + stars + last3 (e.g. `joh****doe`); short values collapse to `****`. */
export function maskPiiValue(value: string): string {
  if (value.length <= 4) return "****"
  if (value.length <= 8) return value.slice(0, 2) + "****"
  return value.slice(0, 3) + "****" + value.slice(-3)
}

/** Masks the local part, keeps the domain (e.g. `joh****doe@acme.com`). */
export function maskEmail(email: string): string {
  const atIndex = email.indexOf("@")
  if (atIndex <= 0) return maskPiiValue(email)
  return maskPiiValue(email.slice(0, atIndex)) + email.slice(atIndex)
}

/** prefix + last4, length hidden (e.g. `sk-...1a2b`); ≤7 chars → `••••`. */
export function maskKeyTail(value: string): string {
  if (!value) return value
  if (value.length <= 7) return "••••"
  return `${value.slice(0, 3)}...${value.slice(-4)}`
}
